import { login } from '@/api/model/user'
import tool from '@/utils/tool'
// import { getToken, setToken, removeToken } from '@/utils/auth'

const state = {
  token: localStorage.getItem('token'),
  name: '',
  avatar: '',
  introduction: '',
  roles: [],
  rememberMe: 0,
  loginTime: ''
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_REMEMBER: (state, rememberMe) => {
    state.rememberMe = rememberMe
  },
  SET_LOGIN_TIME: (state, loginTime) => {
    state.loginTime = loginTime
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      login({ username: userInfo.username, password: userInfo.password }).then(response => {
        console.log('response', response);
        if (response.code === 0) {
          const nowDate = tool.dateFormat(new Date(), 'yyyy-MM-dd hh:mm:ss')
          const { data } = response
          commit('SET_TOKEN', data.token)
          commit('SET_REMEMBER', userInfo.rememberMe)
          commit('SET_LOGIN_TIME', nowDate)
          localStorage.setItem('token', data.token)
          var myGrid = tool.data.get("DASHBOARDGRID")
          var grid = tool.data.get("grid")
          tool.data.set("DASHBOARDGRID", myGrid)
          tool.data.set("grid", grid)
          data.user.dashboard = '0'
          let role = []
          // if (userInfo.username === 'jack') {
          //   role.push('admin')
          // } else {
          //   role.push('other')
          // }
          role.push('admin')
          var userInfo2 = {
            userId: data.user.id,
            userName: userInfo.username,
            dashboard: 1,
            role: role,
            rememberMe: userInfo.rememberMe,
            loginTime: nowDate
          }
          tool.data.set('userInfo2', userInfo2)
        }
        resolve(response)
      }).catch(error => {
        console.log('error', error);
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
